import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Layout, Menu, Icon, Button } from 'antd';
import { dispatch } from '../../App';
import LoginModal from './LoginModal';
import 'antd/dist/antd.css';
import pageStyle from '../css/template.css';

const { Header, Sider, Content } = Layout;
const SubMenu = Menu.SubMenu;

class TemplateView extends React.Component {

    constructor() {
        super();
        this.onSelectMenu = this.onSelectMenu.bind(this);
        this.onOpenChangeMenu = this.onOpenChangeMenu.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        if (!localStorage.getItem('token')) {
            dispatch.common.isLogin(false);
        } else {
            dispatch.common.isLogin(true);
        }
    }

    onSelectMenu(item) {
        this.props.history.push(item.key);
    }

    onOpenChangeMenu(openKeys) {
        dispatch.template.setOpenKeys(openKeys);
    }

    onClick(type) {
        switch (type) {
            case 'toggle':
                dispatch.template.toggle();
                break;
            case 'logout':
                localStorage.removeItem('token');
                dispatch.common.isLogin(false);
                break;
            case 'login-modal-close':
                dispatch.common.isLogin(true);
                break;
            default:
                break;
        }
    }

    render() {
        let path = this.props.location.pathname.toString();
        if (path.split('/').length > 3) {
            path = path.substring(0, path.lastIndexOf('/'));
        }
        if (this.props.openKeys.indexOf(path.split('/')[1]) === -1) {
            this.props.openKeys.push(path.split('/')[1]);
        }
        return (
            <Layout className="match-parent">
                <Sider trigger={null} collapsible collapsed={this.props.collapsed}>
                    <Menu theme="dark" mode="inline" openKeys={this.props.openKeys} selectedKeys={[path]} onSelect={this.onSelectMenu} onOpenChange={this.onOpenChangeMenu}>
                        <Menu.Item key="/index">
                            <Icon type="home" />
                            <span>首页</span>
                        </Menu.Item>
                        <SubMenu key="account" title={<span><Icon type="book" /> <span>账号信息管理</span></span>}>
                            <Menu.Item key="/account/platform">平台管理</Menu.Item>
                            <Menu.Item key="/account/account">账号管理</Menu.Item>
                        </SubMenu>
                        <SubMenu key="coin" title={<span><Icon type="dollar" /> <span>数字货币管理</span></span>}>
                            <Menu.Item key="/coin/huobi">火币现货</Menu.Item>
                            <Menu.Item key="/coin/quantRobot">量化实盘</Menu.Item>
                        </SubMenu>
                        <SubMenu key="tool" title={<span><Icon type="tool" /> <span>工具箱</span></span>}>
                            <Menu.Item key="/tool/md5">MD5 加密</Menu.Item>
                        </SubMenu>
                    </Menu>
                </Sider>
                <Layout>
                    <Header className={pageStyle['header']}>
                        <Icon className={pageStyle['icon']} type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={() => this.onClick('toggle')} />
                        <Button type="primary" onClick={() => this.onClick('logout')}>退出登录</Button>
                    </Header>
                    <Content>
                        {this.props.children}
                    </Content>
                </Layout>
                {!this.props.isLogin &&
                    <LoginModal onModalCancel={() => this.onClick('login-modal-close')} onModalFinish={() => this.onClick('login-modal-close')} />
                }
            </Layout>
        );
    }

}

export const template = {
    state: {
        collapsed: false,
        openKeys: [],
        isLogin: true
    },
    reducers: {
        toggle(state) {
            return Object.assign({}, state, {
                collapsed: !state.collapsed
            });
        },
        setOpenKeys(state, openKeys) {
            return Object.assign({}, state, {
                openKeys: openKeys
            });
        }
    }
}

const mapState = state => ({
    collapsed: state.template.collapsed,
    openKeys: state.template.openKeys,
    isLogin: state.common.isLogin
});


const Template = connect(mapState, null)(TemplateView);
export default withRouter(Template);


// WEBPACK FOOTER //
// ./src/page/jsx/Template.jsx